import { PermissionsActiveDialog } from "@/enums/permissions-active-dialog";

export default {
  memberDialog: state => state.activeDialog === PermissionsActiveDialog.MEMBERS,

  facilitiesDialog: state =>
    state.activeDialog === PermissionsActiveDialog.FACILITIES,

  facilitiesGroupsDialog: state =>
    state.activeDialog === PermissionsActiveDialog.FACILITIES_Groups,

  permissionsDialog: state =>
    state.activeDialog === PermissionsActiveDialog.PERMISSIONS,

  permissionsPreviewDialog: state =>
    state.activeDialog === PermissionsActiveDialog.PERMISSIONS_PREVIEW,

  permissionsGrantedDialog: state =>
    state.activeDialog === PermissionsActiveDialog.COMPLETE,

  facilitiesCount: (state, getters, rootState) => {
    return state.member.allFacilitiesAccess
      ? Object.values(
          rootState.company.company.company_user.facilities_access_count
        ).reduce((previousValue, currentValue) => previousValue + currentValue)
      : Object.values(state.member.facilitiesAccessCount).reduce(
          (previousValue, currentValue) => previousValue + currentValue
        ) || 0;
  },

  facilitiesGroupsCount: (state, getters, rootState) => {
    return state.member.facilitiesGroupsAccessCount;
  },

  permission: state => key => state.member.permissions[key],

  editMode: state => state.mode === "edit",

  previewMode: state => state.mode === "preview"
};
